/* eslint-disable max-len */
import React from 'react';

export const EligibilityCheckSVG = ({
  brandSecondary,
  brandPrimary,
  brandSecondaryBackground,
  brandTint,
  brandShade1,
  brandShade2,
  brandPrimaryBackground,
}: SVGThemeProps) => (
  <svg
    width={280}
    height={216}
    viewBox="0 0 280 216"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Eligibility check confirmation illustration"
  >
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.25}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.961 166.146C166.193 170.39 192.431 161.062 227.139 133.625C257.511 109.616 266.216 72.7924 261.276 50.0914C256.463 27.9729 241.956 8.95442 221.509 3.67142C201.343 -1.53858 181.883 4.82742 151.752 31.3459C121.62 57.8644 97.1908 60.1939 79.2288 64.3604C61.2673 68.5274 36.6178 82.0244 39.7868 109.714C42.9568 137.404 89.6668 163.514 118.961 166.146Z"
        fill={brandSecondary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.25}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.8324 64.8366C25.2979 78.9241 10.9054 99.9156 16.8584 136.736C22.2859 170.308 53.5619 198.806 101.403 199.872C149.384 200.942 177.028 155.58 171.889 136.756C166.751 117.932 130.819 134.603 124.185 105.842C117.55 77.0816 115.772 61.1111 90.9064 56.3211C70.6019 52.4096 53.4364 58.6316 44.8324 64.8366Z"
        fill={brandPrimary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.051 196.348C197.267 223.132 136 215.777 106.61 186.387C77.2201 156.997 85.5936 111.459 112.377 84.6746C139.162 57.8906 200.428 44.2746 229.818 73.6646C259.208 103.055 250.835 169.565 224.051 196.348Z"
        fill={brandSecondaryBackground}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.295 147.339C84.8673 147.339 54.2438 108.36 54.2438 74.9712C54.2438 41.5822 84.8673 20.4717 115.295 20.4717C145.723 20.4717 188.259 47.5382 188.259 80.9272C188.259 114.316 145.723 147.339 115.295 147.339Z"
        fill={brandTint}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165.925 170.982H117.075C112.634 170.982 109 167.348 109 162.908V54.075C109 49.6335 112.634 46 117.075 46H165.925C170.367 46 174 49.6335 174 54.075V162.908C174 167.348 170.367 170.982 165.925 170.982Z"
      fill={brandShade2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.925 170.982H114.075C109.634 170.982 106 167.348 106 162.908V54.075C106 49.6335 109.634 46 114.075 46H162.925C167.367 46 171 49.6335 171 54.075V162.908C171 167.348 167.367 170.982 162.925 170.982Z"
      fill={brandPrimary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M111.892 158.919C111.279 158.919 110.78 158.421 110.78 157.808V61.8244C110.78 61.2114 111.279 60.7129 111.892 60.7129H165.109C165.721 60.7129 166.22 61.2114 166.22 61.8244V157.808C166.22 158.421 165.721 158.919 165.109 158.919H111.892Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M133.247 55.6816H146.754C147.164 55.6816 147.5 55.3461 147.5 54.9356V54.4281C147.5 54.0176 147.164 53.6816 146.754 53.6816H133.247C132.836 53.6816 132.5 54.0176 132.5 54.4281V54.9356C132.5 55.3461 132.836 55.6816 133.247 55.6816Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M130.247 55.6816H130.754C131.164 55.6816 131.5 55.3461 131.5 54.9356V54.4281C131.5 54.0176 131.164 53.6816 130.754 53.6816H130.247C129.836 53.6816 129.5 54.0176 129.5 54.4281V54.9356C129.5 55.3461 129.836 55.6816 130.247 55.6816Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M156.5 108.491C156.5 118.432 148.442 126.491 138.5 126.491C128.559 126.491 120.5 118.432 120.5 108.491C120.5 98.5497 128.559 90.4912 138.5 90.4912C148.442 90.4912 156.5 98.5497 156.5 108.491Z"
      fill="#73BE5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M136.363 118.496L127.147 109.283L130.371 106.06L136.363 112.05L142.372 106.043L142.71 105.717L146.63 101.798L149.853 105.022L139.389 115.485L139.049 115.809L136.363 118.496Z"
      fill="#317A20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M136.363 117.183L127.147 107.97L130.371 104.747L136.363 110.737L142.372 104.73L142.71 104.405L146.63 100.486L149.853 103.709L139.389 114.172L139.049 114.497L136.363 117.183Z"
      fill="white"
    />
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M241 108.111C241 112.529 237.418 116.111 233 116.111C228.582 116.111 225 112.529 225 108.111C225 103.693 228.582 100.111 233 100.111C237.418 100.111 241 103.693 241 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212 108.111C212 110.32 210.209 112.111 208 112.111C205.791 112.111 204 110.32 204 108.111C204 105.902 205.791 104.111 208 104.111C210.209 104.111 212 105.902 212 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M263 108.111C263 110.32 261.209 112.111 259 112.111C256.791 112.111 255 110.32 255 108.111C255 105.902 256.791 104.111 259 104.111C261.209 104.111 263 105.902 263 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M280 108.111C280 109.216 279.105 110.111 278 110.111C276.895 110.111 276 109.216 276 108.111C276 107.007 276.895 106.111 278 106.111C279.105 106.111 280 107.007 280 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190 108.111C190 109.216 189.105 110.111 188 110.111C186.895 110.111 186 109.216 186 108.111C186 107.007 186.895 106.111 188 106.111C189.105 106.111 190 107.007 190 108.111Z"
        fill={brandSecondary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55 108.111C55 112.529 51.4185 116.111 47 116.111C42.5815 116.111 39 112.529 39 108.111C39 103.693 42.5815 100.111 47 100.111C51.4185 100.111 55 103.693 55 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 108.111C26 110.32 24.209 112.111 22 112.111C19.791 112.111 18 110.32 18 108.111C18 105.902 19.791 104.111 22 104.111C24.209 104.111 26 105.902 26 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77 108.111C77 110.32 75.209 112.111 73 112.111C70.791 112.111 69 110.32 69 108.111C69 105.902 70.791 104.111 73 104.111C75.209 104.111 77 105.902 77 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94 108.111C94 109.216 93.1045 110.111 92 110.111C90.8955 110.111 90 109.216 90 108.111C90 107.007 90.8955 106.111 92 106.111C93.1045 106.111 94 107.007 94 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 108.111C4 109.216 3.1045 110.111 2 110.111C0.8955 110.111 0 109.216 0 108.111C0 107.007 0.8955 106.111 2 106.111C3.1045 106.111 4 107.007 4 108.111Z"
        fill={brandSecondary}
      />
    </g>
  </svg>
);
